let i = 1;
export default function uid() {
	return i++;
}
/* Метод нужен для того чтобы при серверном и клиентском рендере id совпадали */
export function resetUid() {
	i = 1;
}
